import React, {Component} from 'react';
import {browserHistory} from 'react-router'
import axios from 'axios';
import PopupPolicy from './components/PopupPolicy';
import PopupParking from './components/PopupParking';
import PopupThank from './components/PopupThank';
import Loader from 'react-loader';
import { BASE_URL } from './constants/api';

class StepFour extends Component {
    constructor(props) {
        super(props);
        this.onBtnClickHandler = this.onBtnClickHandler.bind(this);
        this.handleIAgree = this.handleIAgree.bind(this);
        this.handleIAgreeParking = this.handleIAgreeParking.bind(this);
        this.createAppointment = this.createAppointment.bind(this);
        this.activePopupPolicy = this.activePopupPolicy.bind(this);
        this.inactivePopupPolicy = this.inactivePopupPolicy.bind(this);
        this.activePopupParking = this.activePopupParking.bind(this);
        this.inactivePopupParking = this.inactivePopupParking.bind(this);
        this.activePopupThank = this.activePopupThank.bind(this);
        this.inactivePopupThank = this.inactivePopupThank.bind(this);
        this.onBtnBack = this.onBtnBack.bind(this);
        this.state = {
            appointment_details: {},
            appointment: {},
            userData: {},
            services: [],
            servicesData: {},
            sum: 0.00,
            payment_details: {credits_used: '0'},
            promo_code: '',
            iAgree: false,
            validField: {},
            hst: 0.0,
            popupPolicy: false,
            popupThank: false,
            start_date: '',
            loaded: true
        }
    }

    onBtnBack(e) {
        e.preventDefault();
        browserHistory.push(`/StepThree`)
    }

    activePopupThank() {
        this.setState({popupThank: true});
    }

    inactivePopupThank(e) {
        this.setState({popupThank: e});
        localStorage.removeItem("servicesData");
        localStorage.removeItem("appointment_details");
        localStorage.removeItem("appointment");
        localStorage.removeItem("services");
        browserHistory.push(`/ChooseServices`)
    }

    activePopupPolicy() {
        this.setState({popupPolicy: true});
    }

    inactivePopupPolicy(e) {
        this.setState({popupPolicy: e});
    }

    activePopupParking() {
        this.setState({popupParking: true});
    }

    inactivePopupParking(e) {
        this.setState({popupParking: e});
    }

    handleIAgreeParking() {
        this.setState({iAgreeParking: !this.state.iAgreeParking});
    }

    handleIAgree() {
        this.setState({iAgree: !this.state.iAgree});
    }


    componentWillMount() {
        let user = localStorage.getItem('user')
        if (!user) {
            browserHistory.push(`/StepOne`)
        } else {
            let user = JSON.parse(localStorage.getItem('user'));
            this.setState(
                {
                    appointment_details: JSON.parse(localStorage.getItem('appointment_details')),
                    appointment: JSON.parse(localStorage.getItem('appointment')),
                    userData: user,
                    services: JSON.parse(localStorage.getItem('services')),
                    servicesData: JSON.parse(localStorage.getItem('servicesData')),
                }, this.summation);
            if (user.user_data.billing_profile) {
                let billing_profile = user.user_data.billing_profile;
                this.setState({
                    payment_details: {
                        cardname: billing_profile.credit_card.first_name + ' ' + billing_profile.credit_card.last_name,
                        cardmonth: billing_profile.credit_card.expiry_month,
                        cardyear: billing_profile.credit_card.expiry_year,
                        card_number: billing_profile.credit_card.number,
                        credits_used: '0'
                    }
                })
            }
        }
    }

    validationCardName(cardname) {
        this.setState({validField: {'cardname': ''}});
        if (!cardname) {
            return 'empty';
        } else {
            return ''
        }
    }

    validationCardNumber(card_number) {
        this.setState({validField: {'card_number': ''}});
        if (!card_number) {
            return 'empty';
        } else if (card_number.length != 16) {
            return 'invalid'
        } else {
            return ''
        }
    }

    validationSecurityNumber(sec_num) {
        this.setState({validField: {'sec_num': ''}});
        if (!sec_num) {
            return 'empty';
        } else {
            return ''
        }
    }

    validationCardMonth(cardmonth) {
        this.setState({validField: {'cardmonth': ''}});
        if (!cardmonth) {
            return 'empty';
        } else {
            return ''
        }
    }

    validationCardYear(cardyear) {
        this.setState({validField: {'cardyear': ''}});
        if (!cardyear) {
            return 'empty';
        } else {
            return ''
        }
    }

    checkCard() {
        if (this.state.userData.user_data.billing_profile) {
            let billing_profile = this.state.userData.user_data.billing_profile.credit_card;
            return (billing_profile.first_name + ' ' + billing_profile.last_name) === this.state.payment_details.cardname &&
                billing_profile.number === this.state.payment_details.card_number &&
                billing_profile.expiry_month === this.state.payment_details.cardmonth &&
                billing_profile.expiry_year === this.state.payment_details.cardyear
        } else {
            return false
        }
    }

    validationPayment(payData) {
        let valid = true;
        let data = {};
        data['cardname'] = this.validationCardName(payData.cardname);
        data['cardno'] = this.validationCardNumber(payData.card_number);
        data['secno'] = this.validationSecurityNumber(payData.sec_num);
        data['cardmonth'] = this.validationCardMonth(payData.cardmonth);
        data['cardyear'] = this.validationCardYear(payData.cardyear);

        this.setState({validField: data});

        for (let k in data) {
            if (data[k] != "") {
                this.setState({validField: Object.assign({}, this.state.validField, data)});
                valid = false;
            }
        }
        return valid
    }

    onBtnClickHandler(e) {
        e.preventDefault();

        if (this.validationPayment(this.state.payment_details)) {
            this.setState({loaded: false});
            let self = this;
            let config = {
                headers: {'access-token': this.state.userData['token']}
            };
            if (this.checkCard()) {
                this.createAppointment()
            } else {
                let promoCode = this.state.payment_details['credits_used'];
                let sum = promoCode > 0 ? this.state.sum - promoCode : this.state.sum;
                axios.put(`${BASE_URL}/api/v1/user/billing_profile`, {
                    credit_card: {
                        first_name: this.state.payment_details['cardname'] ? this.state.payment_details['cardname'].split(' ')[0] : '',
                        last_name: this.state.payment_details['cardname'] ? this.state.payment_details['cardname'].split(' ')[1] : '',
                        number: this.state.payment_details['card_number'],
                        cvv: this.state.payment_details['sec_num'],
                        expiry_month: this.state.payment_details['cardmonth'],
                        expiry_year: this.state.payment_details['cardyear'],
                        postal_code: this.state.appointment['postal_code'],
                        amount: sum
                    }
                }, config).then(function (response) {
                    let data = {
                        token: response.headers['access-token'],
                        user_data: response.data
                    };
                    localStorage.removeItem("user");
                    localStorage.setItem('user', JSON.stringify(data))
                    self.createAppointment()
                }).catch(function (error) {
                    if (error.response.data.type == "Unauthorized") {
                        localStorage.removeItem("servicesData");
                        localStorage.removeItem("appointment_details");
                        localStorage.removeItem("appointment");
                        localStorage.removeItem("services");
                        localStorage.removeItem("user");
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        alert(error.response.data.message);
                    }
                });
            }

        }
    }

    createAppointment() {
        let self = this;
        let config = {
            headers: {'access-token': this.state.userData['token']}
        };
        axios.post(`${BASE_URL}/api/v1/group_appointments`, {
            appointment: {
                services: this.state.servicesData,
                date: this.state.appointment_details['datePicker'] + ' ' + this.state.appointment_details['timepick'],
                start_date: this.state.appointment_details['datePicker'] + ' ' + this.state.appointment_details['timepick'],
                address: this.state.appointment['address'],
                city: this.state.appointment['city'],
                postal_code: this.state.appointment['postal_code'],
                phone_number: this.state.appointment['phone_number'],
                special_requests: this.state.appointment_details['specialnotes'] ? this.state.appointment_details['specialnotes'] : '',
                credits_used: this.state.payment_details['credits_used'] ? this.state.payment_details['credits_used'] : '',
            },
            group_appointments: {
                amount_people: this.state.appointment_details['amountPeople'],
                start_date: this.state.appointment_details['datePicker'] + ' ' + this.state.appointment_details['timepick'],
            },
            services: this.state.servicesData
        }, config).then(function (response) {
            self.setState({start_date: response.data.start_date, loaded: true});
            self.activePopupThank()
        }).catch(function (error) {
            this.setState({loaded: true});
            if (error.response.data.type == "Unauthorized") {
                localStorage.removeItem("servicesData");
                localStorage.removeItem("appointment_details");
                localStorage.removeItem("appointment");
                localStorage.removeItem("services");
                localStorage.removeItem("user");
                alert(error.response.data.type);
                browserHistory.push(`/StepOne`)
            } else {
                alert(error.response.data.message);
            }
        });
    }

    summation() {
        let data = this.state.servicesData;
        let result = 0.0

        for (var el in data) {
            let service = this.state.services.filter(function (obj) {
                return obj.id == el;
            });
            result += (service[0].price * data[el])
        }

        this.setState({hst: (result * 0.13)});
        result = (result * 0.13) + result;

        this.setState({sum: this.intToFloat(result, 2)});
    }

    intToFloat(num, decPlaces) {
        return num.toFixed(decPlaces);
    }

    handleInputChange(propName, value) {
        let data = {};
        data[propName] = value.target.value;
        this.setState({payment_details: Object.assign({}, this.state.payment_details, data)});
    }

    render() {
        let billing_profile = this.state.userData.user_data.billing_profile;
        let popupPolicy = this.state.popupPolicy;
        let popupParking = this.state.popupParking;
        let popupThank = this.state.popupThank;
        let date = this.state.appointment_details['datePicker'];
        let time = this.state.appointment_details['timepick'];
        let address = this.state.appointment['address'] + ', ' + this.state.appointment['postal_code'];
        let servicesData = this.state.servicesData;
        let promoCode = this.state.payment_details['credits_used'];
        let sum = promoCode > 0 ? this.state.sum - promoCode : this.state.sum;

        let template_services = [];
        const currentYear = new Date().getFullYear();
        const startYear = currentYear;
        const endYear = currentYear + 5;

        const yearOptions = [];
        for (let year = startYear; year <= endYear; year++) {
          yearOptions.push(<option key={year} value={year - 2000}>{year}</option>);
        }

        for (let el in servicesData) {
            let service = this.state.services.filter(function (obj) {
                return obj.id == el;
            });
            template_services.push(<div className="pricerow">
                <div className="itemname"> {service[0].title} </div>
                <div className="itemprice"> {servicesData[el]} x $ {service[0].price} </div>
            </div>);
        }

        let count = this.state.userData.user_data.credits_available / 5;
        let result = 0;
        let templateCredits = [];

        for (let i = 0; i < count; i++) {
            if (result === 50 || result === this.state.userData.user_data.credits_available) {
                break;
            }
            result += 5;
            templateCredits.push(<option value={result}>${result}</option>)
        }

        let validField = this.state.validField;
        let errorMessageCardName = '';
        let errorMessageCardNumber = '';
        let errorMessageSecurityNumber = '';
        let errorMessageCardMonth = '';
        let errorMessageCardYear = '';

        for (let el in validField) {
            if (el === 'cardname' && validField[el] === 'empty') {
                errorMessageCardName = <em id="email-error" class="state-error">Please enter card name.</em>
            } else if (el === 'cardno' && validField[el] === 'empty') {
                errorMessageCardNumber = <em id="email-error" class="state-error">Please enter card number.</em>
            } else if (el === 'cardno' && validField[el] === 'invalid') {
                errorMessageCardNumber = <em id="email-error" class="state-error">Please enter a valid card number.</em>
            } else if (el === 'secno' && validField[el] === 'empty') {
                errorMessageSecurityNumber = <em id="email-error" class="state-error">Please enter security number.</em>
            } else if (el === 'cardmonth' && validField[el] === 'empty') {
                errorMessageCardMonth = <em id="email-error" class="state-error">Please enter month.</em>
            } else if (el === 'cardyear' && validField[el] === 'empty') {
                errorMessageCardYear = <em id="email-error" class="state-error">Please enter year.</em>
            }
        }

        return (
            <div className="smart-wrap">
                <Loader loaded={this.state.loaded}>
                </Loader>
                <div className="smart-forms smart-container wrap-2">
                    <div className="form-header header-lite">
                        <h4>Payment Details</h4>
                    </div>
                    <div className="form-body smart-steps steps-theme-primary">
                        <form method="post" action="#" id="smart-form">
                            <fieldset>
                                <div className="frm-row">
                                    <div className="section colm colm12">
                                        <label
                                            className={Object.keys(errorMessageCardName).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="cardname"
                                                id="cardname"
                                                className="gui-input"
                                                placeholder="Name on card..."
                                                defaultValue={!billing_profile ? '' : billing_profile.credit_card.first_name + ' ' + billing_profile.credit_card.last_name}
                                                onChange={this.handleInputChange.bind(this, 'cardname')}
                                            />
                                            <span className="field-icon"><i className="fa fa-user"></i></span>
                                        </label>
                                        {
                                            errorMessageCardName
                                        }
                                    </div>
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label
                                            className={Object.keys(errorMessageCardNumber).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="cardno"
                                                id="lastname"
                                                className="gui-input"
                                                placeholder="Card number..."
                                                defaultValue={!billing_profile ? '' : billing_profile.credit_card.number}
                                                onChange={this.handleInputChange.bind(this, 'card_number')}
                                            />
                                            <span className="field-icon"><i
                                                className="fa fa-credit-card"></i></span>
                                        </label>
                                        {
                                            errorMessageCardNumber
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label
                                            className={Object.keys(errorMessageSecurityNumber).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <input
                                                type="text"
                                                name="secno"
                                                id="secno"
                                                className="gui-input"
                                                placeholder="Security number..."
                                                onChange={this.handleInputChange.bind(this, 'sec_num')}
                                            />
                                            <b className="tooltip tip-left-top"><em> This is a three or four diigit
                                                number at the back of your card </em></b>
                                            <span className="field-icon"><i className="fa fa-barcode"></i></span>
                                        </label>
                                        {
                                            errorMessageSecurityNumber
                                        }
                                    </div>
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label for="cardmonth"
                                               className={Object.keys(errorMessageCardMonth).length > 0 ? 'field select state-error' : 'field select'}>
                                            <select
                                                id="cardmonth"
                                                name="cardmonth"
                                                onChange={this.handleInputChange.bind(this, 'cardmonth')}>
                                                <option
                                                    value={!billing_profile ? '' : billing_profile.credit_card.expiry_month}>
                                                    {!billing_profile ? 'Expiry month...' : billing_profile.credit_card.expiry_month}
                                                </option>
                                                <option value="01">01 - Jan</option>
                                                <option value="02">02 - Feb</option>
                                                <option value="03">03 - Mar</option>
                                                <option value="04">04 - Apr</option>
                                                <option value="05">05 - May</option>
                                                <option value="06">06 - Jun</option>
                                                <option value="07">07 - Jul</option>
                                                <option value="08">08 - Aug</option>
                                                <option value="09">09 - Sep</option>
                                                <option value="10">10 - Oct</option>
                                                <option value="11">11 - Nov</option>
                                                <option value="12">12 - Dec</option>
                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                        {
                                            errorMessageCardMonth
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label
                                            className={Object.keys(errorMessageCardYear).length > 0 ? 'field select state-error' : 'field select'}>
                                            <select
                                                id="cardyear"
                                                name="cardyear"
                                                onChange={this.handleInputChange.bind(this, 'cardyear')}>
                                                <option
                                                    value={!billing_profile ? '' : billing_profile.credit_card.expiry_year}>
                                                    {!billing_profile ? 'Expiry year...' : '20' + billing_profile.credit_card.expiry_year}
                                                </option>

                                                {yearOptions}
                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                        {
                                            errorMessageCardYear
                                        }
                                    </div>
                                </div>
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label className="field select">
                                            <select
                                                id="cardyear"
                                                name="cardyear"
                                                onChange={this.handleInputChange.bind(this, 'credits_used')}
                                            >
                                                <option value="0">Choose amount of promo credits</option>
                                                {
                                                    templateCredits
                                                }
                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                    </div>
                                </div>
                                <div className="summary">Order Summary</div>
                                <div className="orderdetails">
                                    <strong>Appointment Date:</strong> {date}<br/>
                                    <strong>Location:</strong> {address}<br/>
                                    <strong>Time:</strong> {time}<br/>
                                </div>
                                <div className="productpicked" style={{"display": "block"}}>
                                    {template_services}
                                    <div className="pricerow taxes">
                                        <div className="itemname">HST</div>
                                        <div className="itemprice">${this.intToFloat(this.state.hst, 2)}</div>
                                    </div>
                                    {
                                        promoCode > 0 &&
                                        <div className="pricerow tip">
                                            <div className="itemname">Promo code:</div>
                                            <div className="itemprice">${promoCode}</div>
                                        </div>
                                    }
                                </div>
                                <div className="thetotals">
                                    <h1 className="page_totals">Total $<span>{sum}</span></h1>
                                </div>
                                <div className="section">
                                    <label className="option option-green">
                                        <input
                                            type="checkbox"
                                            name="info"
                                            checked={this.state.iAgree}
                                            onChange={this.handleIAgree}
                                        />
                                        <span className="checkbox"></span>
                                        <strong style={{"font-weight": "300"}}>I AGREE</strong>
                                        <em className="small-text fine-grey"> By confirming payment, you agree to
                                            our
                                            <a
                                                href="#"
                                                onClick={this.activePopupPolicy}
                                            > cancellation policy </a>
                                            and authorize your card to be charged for the
                                            services.
                                            Your card will be charged upon the completion of your appointment.</em>
                                    </label>
                                </div>
                                <div className="section">
                                    <label className="option option-green">
                                       <input
                                           type="checkbox"
                                           name="info"
                                           checked={this.state.iAgreeParking}
                                           onChange={this.handleIAgreeParking}
                                       />
                                      <span className="checkbox"></span>
                                      <strong>I AGREE</strong>
                                      <em className="small-text fine-grey"> By confirming payment, you agree to
                                                our
                                                <a
                                                href="#"
                                            onClick={this.activePopupParking}
                                                > parking  policy </a>
                                                .</em>
                                            </label>
                                </div>

                                <div className="controls">
                                    <div className="sendit">
                                        <button
                                            type="submit"
                                            className="button btn-primary"
                                            disabled={!this.state.iAgree || !this.state.iAgreeParking}
                                            onClick={this.onBtnClickHandler}
                                        > REQUEST APPOINTMENT
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center backer">
                                    <a
                                        href="#"
                                        className="back"
                                        onClick={this.onBtnBack}
                                    >&larr;  Back</a>
                                </div>
                                <div className="result"></div>
                            </fieldset>
                        </form>
                    </div>
                </div>
                {
                    popupPolicy &&
                    <PopupPolicy
                        inactivePopupPolicy={this.inactivePopupPolicy}
                    />
                }
                {
                    popupParking &&
                    <PopupParking
                            inactivePopupParking={this.inactivePopupParking}
                    />
                }   
                {
                    popupThank &&

                    <PopupThank
                        inactivePopupThank={this.inactivePopupThank}
                        timePicker={this.state.appointment_details.timepick}
                        datePicker={this.state.appointment_details.datePicker}
                    />
                }
            </div>
        )
    }
}

export default StepFour;



/** WEBPACK FOOTER **
 ** ./src/StepFour.js
 **/